// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `input[type=radio].radio-button {
  visibility: hidden;
  cursor: pointer;
}
input[type=radio].radio-button:before {
  display: inline-block;
  content: " ";
  width: 20px;
  height: 20px;
  border-radius: 50%;
  border: 2px solid #aa004f;
  visibility: initial;
  margin-top: -5px;
  box-sizing: border-box;
}
input[type=radio].radio-button:checked:before {
  border: 7px solid #aa004f;
}`, "",{"version":3,"sources":["webpack://./src/widgets/RadioButton/styles.scss"],"names":[],"mappings":"AAEA;EACE,kBAAA;EACA,eAAA;AADF;AAEE;EACE,qBAAA;EACA,YAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,yBAAA;EACA,mBAAA;EACA,gBAAA;EACA,sBAAA;AAAJ;AAGI;EACE,yBAAA;AADN","sourcesContent":["@import \"../../css/colors\";\n\ninput[type=\"radio\"].radio-button {\n  visibility: hidden;\n  cursor: pointer;\n  &:before {\n    display: inline-block;\n    content: \" \";\n    width: 20px;\n    height: 20px;\n    border-radius: 50%;\n    border: 2px solid $color6;\n    visibility: initial;\n    margin-top: -5px;\n    box-sizing: border-box;\n  }\n  &:checked {\n    &:before {\n      border: 7px solid $color6;\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
